import * as _ from 'lodash';
import {editor, IPosition, languages} from 'monaco-editor';

export const cleanConfig = (config: {[key: string]: any}) => {
  const configCopy = {...config};

  Object.entries(configCopy).forEach(([k, v]) => {
    if (_.isObject(v) && 'value' in v) {
      configCopy[k] = configCopy[k].value;
    } else if (k.includes('.desc')) {
      delete configCopy[k];
    } else if (_.isObject(v)) {
      configCopy[k] = cleanConfig(v);
    }
  });
  return configCopy;
};

export interface ArtifactInfos {
  name: string;
  entity: string;
  project: string;
  label: string;
  version: string;
}

export const RESOURCE_CONFIGS = {
  kubernetes: {
    namespace: 'wandb',
    job_labels: {},
    registry: '',
    job_spec: '',
  },
  'gcp-vertex': {
    gcp_staging_bucket: '',
    gcp_artifact_repo: '',
    gcp_machine_type: 'n1-standard-4',
    gcp_accelerator_type: 'ACCELERATOR_TYPE_UNSPECIFIED',
    gcp_accelerator_count: 0,
  },
  sagemaker: {
    RoleArn: '',
    EcrRepoName: '',
    ResourceConfig: {
      InstanceType: 'ml.m4.xlarge',
      InstanceCount: 1,
      VolumeSizeInGB: 2,
    },
    OutputDataConfig: {S3OutputPath: ''},
    StoppingCondition: {
      MaxRuntimeInSeconds: 3600,
    },
  },
  'local-container': '',
  'local-process': '',
};

export type ResourceConfigKeys = keyof typeof RESOURCE_CONFIGS;
export const getCompletionValues = (
  dict: {[key: string]: ArtifactInfos},
  model: editor.ITextModel,
  position: IPosition
) => {
  const items: languages.CompletionItem[] = Object.keys(dict).map(key => {
    return {
      filterText: key,
      label: key,
      insertText: key,
      kind: languages.CompletionItemKind.Function,
      range: {
        startLineNumber: position.lineNumber,
        endLineNumber: position.lineNumber,
        endColumn: model.getWordUntilPosition(position).endColumn,
        startColumn: model.getWordUntilPosition(position).startColumn,
      },
    };
  });
  return items;
};
export const autoPopulateConfigResources = (
  resourceName: ResourceConfigKeys
) => {
  const resourceConfig = RESOURCE_CONFIGS[resourceName];
  if (resourceConfig === '') {
    return resourceConfig;
  }
  return JSON.stringify(
    {resource_args: {[resourceName]: RESOURCE_CONFIGS[resourceName]}},
    null,
    2
  );
};

interface TypedObject {
  _type: string;
  id: string;
}

function isTypedObject(o: object): o is TypedObject {
  return '_type' in o && 'id' in o;
}

function isArtifactVersion(t: TypedObject) {
  return t._type === 'artifactVersion';
}

export const swapArtifactObjects = (spec: Record<string, unknown> | object) => {
  const swappedSpec = {...spec};
  Object.keys(swappedSpec).forEach(key => {
    const value: unknown = swappedSpec[key];
    if (!_.isObject(value)) {
      return value; // early return the non-objects //
    }
    if (isTypedObject(value) && isArtifactVersion(value)) {
      swappedSpec[key] = 'wandb-artifact://_id/' + value.id;
    } else {
      swappedSpec[key] = swapArtifactObjects(value);
    }
  });
  return swappedSpec;
};
